import { catchError } from '@utils/sentry';
import { call } from 'redux-saga/effects';
import { runSaga } from 'redux-saga';
import { triggerToast } from '@components/base/Notification';
/**
 * Runs a generator-returning saga call and settles it instead of letting the error propagate,
 * so a caller batching several of these under `all()` (e.g. Promise.allSettled-style) can tell
 * which ones succeeded and which failed without one failure aborting the whole batch.
 */
export function* callSafely(fn, ...args) {
    try {
        const value = (yield call(fn, ...args));
        return { status: 'fulfilled', value };
    }
    catch (error) {
        return { status: 'rejected', error: error };
    }
}
export function* handleSagaSuccess({ callback, response, }) {
    try {
        if (callback) {
            yield call(callback, response ?? {});
        }
    }
    catch (error) {
        triggerToast({
            message: {
                title: `Unexpected response`,
                summary: error.message || `Something went wrong while processing your request. Please try again.`,
            },
            variant: 'danger',
        });
    }
}
export function* handleSagaError({ callback, error, title = 'Saga Title Error', skipToast = false, }) {
    try {
        if (callback) {
            yield call(callback, error);
        }
        yield call(catchError, { title, error, skipToast });
    }
    catch (nestedError) {
        triggerToast({
            message: {
                title: `Error while processing request`,
                summary: nestedError.message || `We ran into a problem. Please try again shortly.`,
            },
            variant: 'danger',
        });
    }
}
const testSagaExecution = async (saga, initialAction, mockResponse) => {
    const dispatched = [];
    await runSaga({
        dispatch: (action) => dispatched.push(action),
        getState: () => mockResponse || {},
    }, saga, initialAction).toPromise();
    return dispatched;
};
export default testSagaExecution;
